// extracted by mini-css-extract-plugin
module.exports = {"noReportsMessage":"NoReportsMessage_noReportsMessage__2BE86"};